import { useTranslation } from 'react-i18next';
import { LoanFormValues } from '../../Loan';
import { useFormContext } from 'react-hook-form';
import { CreateFileV2 } from '../../File';
import { useLoanFormContext } from '..';

interface LoanCreateFileInputProps {
  className?: string;
}

export const LoanCreateFileInput = ({ className }: LoanCreateFileInputProps) => {
  const { t: tForm } = useTranslation('form');
  const { householdID } = useLoanFormContext();
  const { setValue, watch } = useFormContext<LoanFormValues>();

  const [pendingFiles] = watch(['pendingFiles']);

  return (
    <CreateFileV2
      className={className}
      tenantID={householdID}
      label={tForm('general-add-related-documents')}
      onFileCreation={(file) => setValue('pendingFiles', (pendingFiles || []).concat(file))}
    />
  );
};
